module.exports = __webpack_public_path__ + "static/media/n-53-shot-1.35231bba.webp";